require('./loanPartialAmortizationWizard.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { formatText } = require('core/i18n').i18n;
// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
// @ components
const LoanPartialAmortizationStep1 = require('../loanPartialAmortizationStep1/loanPartialAmortizationStep1');
const LoanPartialAmortizationStep2 = require('../loanPartialAmortizationStep2/loanPartialAmortizationStep2');
const LoanPartialAmortizationSuccess = require('../loanPartialAmortizationSuccess/loanPartialAmortizationSuccess');
const LoanPartialAmortizationError = require('../loanPartialAmortizationError/loanPartialAmortizationError');
// @ actions
const partialAmortizationAction = require('../../../../actions/loanPartialAmortization');
const collectiveActions = require('actions/collectives');
const profileActions = require("actions/profile");
const preContractualMailInfoActions = require("actions/preContractualMailInfo");

// @constants
const { MULTICHANNEL_UI_COMPONENT } = require('constants/index');
const { NOT_ALLOWED_EVIDENCE_PARTIAL_LOAN_REPAYMENT_COUNTRIES } = require("constants/flagBasedFeatures");
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

class LoanPartialAmortizationWizard extends React.Component {

    constructor(props) {
        super(props);

        this.onCancel = this.onCancel.bind(this);
        this.setVisibleStep = this.setVisibleStep.bind(this);
    }

    componentDidMount() {
        const { getCollectiveInfo, immLoan, immAccounts, requestPartialAmortization, requestPlanAmortization } = this.props;

        if (immLoan) {
            const productType = {
                type: immLoan.get('product'),
                subType: immLoan.get('productSubType'),
                standard: immLoan.get('productStandard')
            };

            requestPartialAmortization(immLoan, immAccounts);
            requestPlanAmortization(immLoan);
            getCollectiveInfo([productType], MULTICHANNEL_UI_COMPONENT);
        }
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    onCancel() {
        this.props.onCancel();
    }

    setVisibleStep(step) {
        this.props.setVisibleStep({ step });
    }

    render() {
        const {
            immPartialAmortization,
            postChange,
            productName,
            immLoan,
            requestPartialAmortization,
            requestPlanAmortization,
            updateEnoughBalance,
            setWillCancel,
            validateStep,
            immFlagBasedFeatures,
            checkReadDocument,
            immProfile,
            immAccounts,
            requestProfile,
            sendMail,
            preContractualMail,
            downloadOrPrintDocument
        } = this.props;

        const actions = {
            validateStep: validateStep,
            setVisibleStep: this.setVisibleStep,
            setWillCancel: setWillCancel,
            cancel: this.onCancel,
            finish: postChange
        };

        const immSteps = immPartialAmortization.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immPartialAmortization.get('visibleStep');
        const immFinalButton = 'loanPartialAmortization-finalButton';
        const inProgress = immPartialAmortization.get('inProgress');
        const newLoanPartialFF = immFlagBasedFeatures.get(NOT_ALLOWED_EVIDENCE_PARTIAL_LOAN_REPAYMENT_COUNTRIES);
        const productType = immPartialAmortization.getIn(['loanAmortizationParameter', 'type']);
        const officeFinalButtonEnabled = immPartialAmortization.get('downloadOrPrintDocument');

        let content;
        if (immPartialAmortization.get('accountError')) {
            content = <LoanPartialAmortizationError accountError />;
        } else if (!immLoan || immPartialAmortization.get('error')) {
            content = <LoanPartialAmortizationError />;
        } else if (immPartialAmortization.get('success')) {
            content = (
                <LoanPartialAmortizationSuccess
                    immLoan={immLoan}
                    immPartialAmortization={immPartialAmortization}
                    requestPartialAmortization={requestPartialAmortization}
                    requestPlanAmortization={requestPlanAmortization}
                />
            );
        } else {
            const simulatorData = immPartialAmortization.get('partialAmortizationSimulationData');
            const nextButtonDisabled = simulatorData.get('isFetching') || simulatorData.get('hasAmountError') || !simulatorData.get('amount') || !simulatorData.get('amortizationType');
            const mailSent = preContractualMail.get('mailSent');
            content = (
                <div className="loan-partial-amortization-wizard">
                    <Wizard
                        actions={actions}
                        stepsAmount={stepsAmount}
                        visibleStep={visibleStep}
                        immSteps={immSteps}
                        isFetching={inProgress}
                    >
                        <WizardStep
                            nextButtonDisabled={nextButtonDisabled}
                            position="first"
                            cancelButton
                        >
                            <LoanPartialAmortizationStep1
                                productName={productName}
                                immLoan={immLoan}
                                immPartialAmortization={immPartialAmortization}
                                updateEnoughBalance={updateEnoughBalance}
                                newLoanPartialFF={newLoanPartialFF}
                            />
                        </WizardStep>
                        <WizardStep
                            position="last"
                            cancelButton
                            previousButton
                            finishButton={false}
                            addLoadingBehaviour
                            immFinalButton={immFinalButton}
                            finalButtonDisabled={__CONTACT_CENTER__ && isPrintOfficeMode() ? !officeFinalButtonEnabled : false}

                        >
                            <LoanPartialAmortizationStep2
                                immLoan={immLoan}
                                immPartialAmortization={immPartialAmortization}
                                newLoanPartialFF={newLoanPartialFF}
                                checkReadDocument={checkReadDocument}
                                immProfile={immProfile}
                                immAccounts={immAccounts}
                                requestProfile={requestProfile}
                                sendMail={sendMail}
                                preContractualMail={preContractualMail}
                                downloadOrPrintDocument={downloadOrPrintDocument}
                            />
                        </WizardStep>
                    </Wizard>
                    {newLoanPartialFF &&
                        <div>
                            <p className="loan-partial-amortization-wizard-text">
                                {productType === 'mortgage'
                                    ? formatText('loanPartialAmortization-footerLegatText4')
                                    : formatText('loanPartialAmortization-footerLegatText1')
                                }
                            </p>
                            <p className="loan-partial-amortization-wizard-text">
                                {productType === 'mortgage'
                                    ? formatText('loanPartialAmortization-footerLegatText3')
                                    : formatText('loanPartialAmortization-footerLegatText2')
                                }
                            </p>
                        </div>
                    }
                </div>
            );
        }

        return content;
    }
}

LoanPartialAmortizationWizard.propTypes = {
    getCollectiveInfo: PropTypes.func.isRequired,
    immPartialAmortization: PropTypes.object.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
    requestPartialAmortization: PropTypes.func.isRequired,
    requestPlanAmortization: PropTypes.func.isRequired,
    updateEnoughBalance: PropTypes.func.isRequired,
    productName: PropTypes.string.isRequired,
    immLoan: PropTypes.object.isRequired,
    immAccounts: PropTypes.object,
    postChange: PropTypes.func.isRequired
};

module.exports.constructor = LoanPartialAmortizationWizard;

module.exports.LoanPartialAmortizationWizard = connect(
    state => ({
        immPartialAmortization: state.loanPartialAmortization,
        immAccounts: state.accounts,
        immProfile: state.profile,
        preContractualMail: state.preContractualMail,

    }),
    {
        getCollectiveInfo: collectiveActions.getCollectiveInfo,
        setVisibleStep: partialAmortizationAction.simpleActions.loanPartialAmortizationWizardSetVisibleStep,
        setWillCancel: partialAmortizationAction.simpleActions.loanPartialAmortizationWizardWillCancel,
        clearRequest: partialAmortizationAction.simpleActions.loanPartialAmortizationWizardClear,
        requestPartialAmortization: partialAmortizationAction.requestPartialAmortization,
        requestPlanAmortization: partialAmortizationAction.requestPlanAmortization,
        validateStep: partialAmortizationAction.validateStep,
        updateEnoughBalance: partialAmortizationAction.simpleActions.loanPartialAmortizationUpdateModal,
        postChange: partialAmortizationAction.postChange,
        checkReadDocument: partialAmortizationAction.checkReadDocument,
        downloadOrPrintDocument: partialAmortizationAction.downloadOrPrintDocument,
        requestProfile: profileActions.requestProfile,
        sendMail: preContractualMailInfoActions.sendLoanPreContractualMail,



    }
)(LoanPartialAmortizationWizard);
